'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

/**
 * Conditionally loads the Google AdSense script.
 * AdSense is DISABLED on all /deals/* pages to protect the account
 * from low-quality traffic and prevent policy violations.
 */
export default function AdSenseScript() {
  const pathname = usePathname();

  // Define the "Safe Zone" – no ads on tunnel/love pages
  const isTunnelPage = pathname.startsWith('/love');

  if (isTunnelPage) {
    return null; // AdSense script is not loaded at all on these pages
  }

  return (
    <Script
      id="adsense-script"
      async
      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8209081290130316"
      crossOrigin="anonymous"
      strategy="lazyOnload"
    />
  );
}
